import {
  getRegularizations as getRegularizationsService,
  approveRegularization as approveRegularizationService,
  rejectRegularization as rejectRegularizationService,
} from "services/company/attendanceManagement/regularization/regularizationService";

import {
  getRegularizationsStart,
  getRegularizationsSuccess,
  getRegularizationsFailure,
  updateRegularizationStatus,
  actionLoadingStart,
  actionLoadingEnd,
} from "./regularizationSlice";

import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch regularization requests
export const fetchRegularizations =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(getRegularizationsStart());

      const response = await getRegularizationsService(params);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(
          getRegularizationsSuccess({
            data: response.data || [],
            pagination: response.pagination,
          }),
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to fetch regularization requests";
        dispatch(getRegularizationsFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Fetch regularization requests error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to fetch regularization requests";
      dispatch(getRegularizationsFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Approve regularization request
export const approveRegularizationRequest =
  (id, currentParams = {}) =>
  async (dispatch) => {
    try {
      dispatch(actionLoadingStart());

      const response = await approveRegularizationService(id);

      if (response?.meta?.status === true || response?.meta?.code === 200) {
        showSuccessToast(
          response?.meta?.message ||
            "Regularization request approved successfully",
        );
        dispatch(
          updateRegularizationStatus({
            id,
            status: "approved",
            approved_by_name: response?.data?.approved_by_name || "Admin",
          }),
        );
        // Refresh the list
        dispatch(fetchRegularizations(currentParams));
        return { success: true };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to approve regularization request";
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Approve regularization request error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to approve regularization request";
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    } finally {
      dispatch(actionLoadingEnd());
    }
  };

// Reject regularization request
export const rejectRegularizationRequest =
  (id, rejectionReason, currentParams = {}) =>
  async (dispatch) => {
    try {
      dispatch(actionLoadingStart());

      const response = await rejectRegularizationService(id, rejectionReason);

      if (response?.meta?.status === true || response?.meta?.code === 200) {
        showSuccessToast(
          response?.meta?.message || "Regularization request rejected",
        );
        dispatch(
          updateRegularizationStatus({
            id,
            status: "rejected",
            rejection_reason: rejectionReason,
          }),
        );
        // Refresh the list
        dispatch(fetchRegularizations(currentParams));
        return { success: true };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to reject regularization request";
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Reject regularization request error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to reject regularization request";
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    } finally {
      dispatch(actionLoadingEnd());
    }
  };
